module.exports = __webpack_public_path__ + "img/usd.11739277.svg";